import is from 'typescript-styled-is'
import Flex from 'typescript-styled-flex'
import { FiToggleLeft, FiToggleRight } from 'react-icons/fi'
import styled, { ITheme } from '../../../../../theme'

export const Text = styled.p`
  font-size: 12px;
  width: 100%;
  margin: 5px 20px 5px 0;
`

export const Header = styled(Flex.withComponent('strong') as any)`
  align-items: center;
  padding: 10px 20px;
  text-transform: uppercase;
`

export const Row = styled(Flex as any)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;

  &:hover {
    background-color: #eee;
    ${is('onClick')`cursor: pointer`};
  }
`

export const DisabledToggler = styled(FiToggleLeft)`
  width: 20px;
  height: 20px;
`

export const EnabledToggler = styled(FiToggleRight)`
  width: 20px;
  height: 20px;
  color: ${(theme: ITheme) => theme.theme.colors.palette.emerald};
`
